// The words @foodamigos/ui's chat parts show or read out, which the package has in English only (their `labels`
// props, 0.3.0); usePlatformAgentLabels hands them to each part.
export default {
  composer: {
    send: 'Trimite',
    stop: 'Oprește',
    attach: 'Atașează fișiere',
    add: 'Adaugă',
    upload_files: 'Încarcă fișiere',
  },
  attachment: {
    uploading: 'Se încarcă {{percent}}%',
    uploading_file: 'Se încarcă {{name}}',
    retry: 'Reîncearcă',
    remove: 'Elimină {{name}}',
    cancel: 'Anulează încărcarea {{name}}',
  },
  // What screen readers hear for each step's state, and the collapsed list's line ("4 steps · 1 failed and was retried").
  steps: {
    pending: 'În așteptare',
    running: 'Rulează',
    done: 'Gata',
    failed: 'Eșuat',
    denied: 'Refuzat',
    background: 'Fundal',
    summary_one: '{{count}} pas',
    summary_few: '{{count}} pași',
    summary_other: '{{count}} de pași',
    failed_count_one: '{{count}} de eșuate',
    failed_count_few: '{{count}} eșuate',
    failed_count_other: '{{count}} de eșuate',
    retried_one: '{{count}} a eșuat și a fost reîncercat',
    retried_few: '{{count}} au eșuat și au fost reîncercate',
    retried_other: '{{count}} au eșuat și au fost reîncercate',
  },
  question: {
    suggested: 'Sugerat',
    withdrawn: 'Nu mai este necesar',
  },
  thread: {
    live_on: 'Live pe {{domain}}',
    unread_one: '{{count}} de noi',
    unread_few: '{{count}} noi',
    unread_other: '{{count}} de noi',
    working: 'Se lucrează',
  },
  // What screen readers hear for each row of a list that needs a look.
  checklist: {
    done: 'Gata',
    running: 'În curs',
    waiting: 'Necesită atenție',
    failed: 'Eșuat',
    pending: 'Încă nu',
    skipped: 'Omis',
  },
  lightbox: {
    enlarge: 'Mărește: {{label}}',
    close: 'Închide',
  },
};
